import { Navigate, useLocation } from 'react-router-dom'
import { usePermissions } from '../model/hooks/use-permissions'
import { RoutePermission } from '../model/types'

interface ProtectedRouteProps {
    children: JSX.Element
    permissions?: RoutePermission[]
}

const PUBLIC_ROUTES = ['/login']

const ROUTE_PERMISSIONS: Record<string, RoutePermission[]> = {
    '/': [RoutePermission.MAIN],
    '/statistics': [RoutePermission.STATISTICS],
    '/posts': [RoutePermission.POSTING],
    '/advertising': [RoutePermission.ADVERTISING],
    '/channels': [RoutePermission.CHANNELS],
    '/profile': [RoutePermission.PROFILE],
    '/settings': [RoutePermission.SETTINGS]
}

export const ProtectedRoute = ({ children, permissions }: ProtectedRouteProps) => {
    const location = useLocation()
    const { hasPermissions } = usePermissions()

    if (PUBLIC_ROUTES.includes(location.pathname)) {
        return <>{children}</>
    }

    const requiredPermissions = permissions || ROUTE_PERMISSIONS[location.pathname] || []

    if (requiredPermissions.length > 0 && !hasPermissions(requiredPermissions)) {
        return <Navigate to="/" replace />
    }

    return <>{children}</>
}
